export default __webpack_public_path__ + "static/media/ferruccio-resta.83f76ea5.png";